import React, { useState } from "react";
import "./ChangePassword.css";
import { FaEye, FaEyeSlash, FaChevronLeft, FaCheck, FaLock } from "react-icons/fa";
import UserService from "../../../api/UserService";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [backendError, setBackendError] = useState("");
  const [success, setSuccess] = useState(false);

  const passwordPattern = /^(?=.*[a-zA-Z])(?=.*\d).{6,}$/;

  const handleSubmit = async () => {
    if (!currentPassword) {
      setBackendError("Veuillez saisir votre mot de passe actuel.");
      return;
    }
    if (!passwordPattern.test(newPassword)) {
      setBackendError("Le nouveau mot de passe doit comporter au moins 6 caractères avec une lettre et un chiffre.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setBackendError("Les mots de passe ne correspondent pas.");
      return;
    }
    if (newPassword === currentPassword) {
      setBackendError("Le nouveau mot de passe doit être différent de l'actuel.");
      return;
    }

    setBackendError("");
    setSaving(true);
    const token = JSON.parse(localStorage.getItem("token")).accessToken;
    try {
      await UserService.changePassword(token, {
        currentPassword,
        newPassword,
      });
      setSuccess(true);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401) {
        setBackendError("Mot de passe actuel incorrect.");
      } else {
        setBackendError("Une erreur est survenue. Veuillez réessayer.");
      }
    } finally {
      setSaving(false);
    }
  };

  const canSubmit =
    currentPassword.length > 0 &&
    newPassword.length > 0 &&
    confirmPassword.length > 0 &&
    !saving;

  return (
    <>
      <div className="chpwd-page">
        <div className="chpwd-container">
          {/* Back link */}
          <button className="chpwd-back" onClick={() => navigate("/profile")}>
            <FaChevronLeft />
            Mon profil
          </button>

          {success ? (
            <div className="chpwd-success">
              <div className="chpwd-success-icon">
                <FaCheck />
              </div>
              <h2 className="chpwd-success-title">Mot de passe mis à jour</h2>
              <button
                className="chpwd-submit"
                onClick={() => navigate("/profile")}
              >
                Retourner au profil
              </button>
            </div>
          ) : (
            <>
          <h1 className="chpwd-title">Modifier le mot de passe</h1>
          <p className="chpwd-subtitle">Choisissez un mot de passe fort.</p>

          <div className="chpwd-card">
            {/* Current password */}
            <div className="chpwd-field">
              <label>Mot de passe actuel</label>
              <div className="chpwd-input-wrap">
                <input
                  type={showCurrent ? "text" : "password"}
                  value={currentPassword}
                  onChange={(e) => { setCurrentPassword(e.target.value); setBackendError(""); }}
                  placeholder="Votre mot de passe actuel"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="chpwd-eye"
                  onClick={() => setShowCurrent((v) => !v)}
                >
                  {showCurrent ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <div className="chpwd-separator" />

            {/* New password */}
            <div className="chpwd-field">
              <label>Nouveau mot de passe</label>
              <div className="chpwd-input-wrap">
                <input
                  type={showNew ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="6+ caractères, 1 lettre et 1 chiffre"
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="chpwd-eye"
                  onClick={() => setShowNew((v) => !v)}
                >
                  {showNew ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {newPassword.length > 0 && !passwordPattern.test(newPassword) && (
                <span className="chpwd-hint chpwd-hint--error">
                  Au moins 6 caractères, une lettre et un chiffre.
                </span>
              )}
              {newPassword.length > 0 && passwordPattern.test(newPassword) && (
                <span className="chpwd-hint chpwd-hint--ok">
                  <FaCheck /> Mot de passe valide
                </span>
              )}
            </div>

            {/* Confirm */}
            <div className="chpwd-field">
              <label>Confirmer le nouveau mot de passe</label>
              <div className="chpwd-input-wrap">
                <input
                  type={showConfirm ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Répéter le nouveau mot de passe"
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="chpwd-eye"
                  onClick={() => setShowConfirm((v) => !v)}
                >
                  {showConfirm ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {confirmPassword.length > 0 &&
                newPassword !== confirmPassword && (
                  <span className="chpwd-hint chpwd-hint--error">
                    Les mots de passe ne correspondent pas.
                  </span>
                )}
              {confirmPassword.length > 0 &&
                newPassword === confirmPassword &&
                confirmPassword.length > 0 && (
                  <span className="chpwd-hint chpwd-hint--ok">
                    <FaCheck /> Les mots de passe correspondent
                  </span>
                )}
            </div>
          </div>

          {backendError && (
            <div className="chpwd-backend-error">{backendError}</div>
          )}

          <button
            className="chpwd-submit"
            onClick={handleSubmit}
            disabled={!canSubmit}
          >
            {saving ? "Enregistrement…" : "Mettre à jour le mot de passe"}
          </button>
            </>
          )}
        </div>
      </div>

    </>
  );
};

export default ChangePassword;
